"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listItem = exports.listItemIcon = exports.listItemText = exports.icon = void 0;

var _react = require("@emotion/react");

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  ol & {\n    counter-increment: custom-counter;\n\n    .css-", "::before {\n      position: absolute;\n      top: 40%;\n      left: 55%;\n      content: counter(custom-counter);\n      color: ", ";\n      font-family: ", ";\n      font-size: ", ";\n      font-weight: ", ";\n      transform: translate(-55%, -40%);\n    }\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  span {\n    font-family: ", ";\n    font-weight: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    letter-spacing: ", ";\n  }\n\n  p {\n    color: ", ";\n    font-size: ", ";\n    line-height: 1.47em;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  height: 24px;\n  width: 24px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var icon = (0, _react.css)(_templateObject());
exports.icon = icon;

var listItemText = function listItemText(alignment) {
  return function (_ref) {
    var name = _ref.name,
        colors = _ref.colors,
        fonts = _ref.fonts,
        fontSizes = _ref.fontSizes,
        fontWeights = _ref.fontWeights,
        lineHeights = _ref.lineHeights,
        letterSpacings = _ref.letterSpacings;
    return (0, _react.css)(_templateObject2(), alignment === 'flex-start' ? "margin-top: ".concat(name === 'legacy' ? '2px' : '3px') : '', fonts.body1, fontWeights.medium, fontSizes.body1, lineHeights.body1, letterSpacings.body1, colors.neutral[600], fontSizes.body3);
  };
};

exports.listItemText = listItemText;
var listItemIcon = (0, _react.css)(_templateObject3());
exports.listItemIcon = listItemIcon;

var listItem = function listItem(variant) {
  return function (_ref2) {
    var colors = _ref2.colors,
        fonts = _ref2.fonts,
        fontSizes = _ref2.fontSizes,
        fontWeights = _ref2.fontWeights;
    return (0, _react.css)(_templateObject4(), listItemIcon.name, variant === 'light' ? colors.accent : colors.primary.main, fonts.caption1, fontSizes.caption1, fontWeights.medium);
  };
};

exports.listItem = listItem;